import { Component, OnInit } from '@angular/core';
import { AuthService } from '../auth.service';
import { Router, 
	     ActivatedRoute , 
	     Params,  
	     Event as RouterEvent,} from '@angular/router';

import { ToastrService } from 'ngx-toastr';

declare var $:any;

@Component({
  selector: 'app-authentication',
  templateUrl: './authentication.component.html',
  styleUrls: ['./authentication.component.scss']
})
export class AuthenticationComponent implements OnInit {

  currentUser:any;

  constructor(
    private authService: AuthService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private toastr: ToastrService,
  	) { }

  ngOnInit() {
  }

  isLoggedIn(): boolean {
    return this.authService.isLoggedIn();
  }

  isLoggedOut(): boolean {
    return !this.authService.isLoggedIn();
  }

}
